











































































































import Tag, { ITag } from '@/models/Tag'
import Tagging from '@/models/Tagging'
import {Component} from 'vue-property-decorator'
import axios from 'axios'
import { apiV1TagPath, apiV1AdminUserPath } from '@/rails/routes'
import User, {IUser} from '@/models/User'
import PageBase, {BreadCrumb} from '@/pages/page-base'

@Component
export default class UserEdit extends PageBase {
  changeEmail = false
  newEmail = ''
  user = new User()
  uiTurnTimings: Array<Tag> = []
  uiTurnReasons: Array<Tag> = []
  recognitionRoutes: Array<Tag> = []
  careerItems = [
    { text: 'PG（プログラマー）', value: 'pg' },
    { text: 'SE（システムエンジニア）', value: 'se' },
    { text: 'PM（プロジェクトマネージャー）', value: 'pm' },
    { text: 'WE（WEB制作関連職）', value: 'we' },
    { text: 'NE（ネットワーク/インフラ）', value: 'ne' },
    { text: 'その他', value: 'other' }
  ]

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '登録者管理一覧',
        to: '/admin/users',
        exact: true
      },
      {
        text: '登録者管理編集'
      }
    ]
  }

  get uiTurnTimingId(): number {
    return this.user.ui_turn_timings.map(t => t.tag_id)[0]
  }

  set uiTurnTimingId(val: number) {
    this.user.ui_turn_timings = [new Tagging({ id: 0, tag_id: val })]
  }

  get uiTurnReasonIds(): Array<number> {
    return this.user.ui_turn_reasons.map(t => t.tag_id)
  }

  set uiTurnReasonIds(val: Array<number>) {
    this.user.ui_turn_reasons = val.map(v => new Tagging({ id: 0, tag_id: v }))
  }

  get recognitionRouteIds(): Array<number> {
    return this.user.recognition_routes.map(t => t.tag_id)
  }

  set recognitionRouteIds(val: Array<number>) {
    this.user.recognition_routes = val.map(v => new Tagging({ id: 0, tag_id: v }))
  }

  async mounted(): Promise<void> {
    try {
      super.mounted()
      const uiTurnReasonsRoot = await axios.get<ITag>(apiV1TagPath('ui_turn_reasons'))
      this.uiTurnReasons = new Tag(uiTurnReasonsRoot.data).children
      const uiTurnTimingsRoot = await axios.get<ITag>(apiV1TagPath('ui_turn_timings'))
      this.uiTurnTimings = new Tag(uiTurnTimingsRoot.data).children
      const recognitionRoutesRoot = await axios.get<ITag>(apiV1TagPath('recognition_routes'))
      this.recognitionRoutes = new Tag(recognitionRoutesRoot.data).children
      const res = await axios.get<IUser>(apiV1AdminUserPath(this.$route.params.id))
      this.user = new User(res.data)
      this.newEmail = this.user.email
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  async save(): Promise<void> {
    if (!(this.$refs.form as HTMLFormElement).validate()) {
      this.showError('入力内容に不備があります。確認してください。')
      return
    }
    try {
      if (this.changeEmail) {
        this.user.email = this.newEmail
      }
      const res = await axios.put(apiV1AdminUserPath(this.$route.params.id), {
        user: this.user.toParams()
      })
      this.user = new User(res.data)
      this.showMessage('変更を保存しました。')
    } catch (e) {
      console.log(e)
    }
  }
}
